import { autocompleteClasses } from '@mui/material';
import { styled } from '@mui/material/styles';

const overlay = (color: string) => `linear-gradient(${color}, ${color})`;

export const CreateCampaignOption = styled('li')(({ theme }) => ({
  color: theme.palette.primary.main,
  fontWeight: theme.typography.fontWeightSemiBold,
  borderBottom: `1px solid ${theme.palette.divider}`,
  position: 'sticky',
  marginTop: -8,
  top: -8,
  zIndex: 100,
  [`.${autocompleteClasses.listbox} &.${autocompleteClasses.option}`]: {
    backgroundColor: theme.palette.background.paper,
    [`&.${autocompleteClasses.focused}`]: {
      backgroundColor: theme.palette.background.paper,
      backgroundImage: overlay(theme.palette.action.hover),
    },
    [`&.${autocompleteClasses.focusVisible}`]: {
      backgroundColor: theme.palette.background.paper,
      backgroundImage: overlay(theme.palette.action.focus),
    },
  },
}));
